export default "__VITE_ASSET__2c68280a__"